export const tabs = (userRoles) => [
  { name: 'shops', label: 'general.shops' },
  userRoles?.parcelAdmin && { name: 'concerns', label: 'general.concerns' },
  { name: 'serviceSuppliers', label: 'general.serviceSuppliers' }
];
